"use client";

import Link from "next/link";
import { Logo2 } from "@/components/icons/assets";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const quickLinks = [
  { label: "About", href: "/about" },
  { label: "How it work", href: "/how-it-works" },
  { label: "Shipping", href: "/shipping" },
  { label: "FAQs", href: "/faqs" },
  { label: "Contact Us", href: "/contact" },
];

const legalLinks = [
  { label: "Cookies", href: "/cookies" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms & Conditions", href: "/terms" },
];

export default function Footer() {
  return (
    <footer className="bg-white">
      {/* Main Footer */}
      <div className="px-4 md:px-8 lg:px-20 py-16">
        <div className="flex flex-col lg:flex-row justify-between">
          {/* Logo & Description */}
          <div className="lg:max-w-sm">
            <Link href="/">
              <Logo2 className="h-10 w-auto mb-6" />
            </Link>
            <p className="font-plus-jakarta text-neutral-300 font-medium text-sm mb-6">
              Discover quality refurbished wheels that fit perfectly a smarter, more sustainable choice.
            </p>
            <div className="flex gap-3 mt-12">
              <Button variant="outline" className="bg-background-50 rounded-xl px-4 py-8 shadow-none border-none flex items-center gap-2">
                <span className="font-plus-jakarta text-sm font-bold text-neutral-500">Sell Wheels</span>
                <div className="cursor-pointer w-10 h-6 rounded-full bg-primary-500 flex items-center justify-center">
                  <ArrowRight className="w-4 h-4 text-white" />
                </div>
              </Button>
              <Button variant="outline" className="bg-background-50 rounded-xl px-4 py-8 shadow-none border-none flex items-center gap-2">
                <span className="font-plus-jakarta text-sm font-bold text-neutral-500">Shop Wheels</span>
                <div className="cursor-pointer w-10 h-6 rounded-full bg-primary-500 flex items-center justify-center">
                  <ArrowRight className="w-4 h-4 text-white" />
                </div>
              </Button>
            </div>
          </div>

          {/* Right Side - Quick Links, Location, Contact */}
          <div className="flex flex-col md:flex-row gap-16">
            {/* Quick Links */}
            <div>
            <h3 className="font-plus-jakarta font-medium text-neutral-300 mb-4">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link href={link.href} className="font-plus-jakarta text-neutral-600 text-sm hover:text-neutral-900">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Location */}
          <div>
            <h3 className="font-plus-jakarta font-medium text-neutral-300 mb-4">Location</h3>
            <p className="font-plus-jakarta text-neutral-600 text-sm">
              Gladsaxe Møllevej 21,
              <br />
              2860 Søborg
            </p>
          </div>

            {/* Contact */}
            <div>
              <h3 className="font-plus-jakarta font-medium text-neutral-300 mb-4">Contact</h3>
              <a href="tel:0397968925" className="font-plus-jakarta text-neutral-600 text-sm mb-2 block hover:text-neutral-900">(03) 9796 8925</a>
              <a href="mailto:question@wheeltox.com" className="font-plus-jakarta text-neutral-600 text-sm hover:text-neutral-900">question@wheeltox.com</a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      {/* <div className="mx-4 md:mx-8 lg:mx-20"></div> */}
      <div className="px-4 md:px-8 lg:px-20 py-10">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-plus-jakarta text-neutral-300 text-sm">
            Copyright © WheelTox 2025. All Rights Reserved
          </p>
          <div className="flex gap-6">
            {legalLinks.map((link) => (
              <Link
                key={link.label}
                href={link.href}
                className="font-plus-jakarta text-neutral-300 text-sm hover:text-neutral-900"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
